<template>
  <!-- 税率信息 -->
  <el-dialog
    :visible.sync="addTaxRatex"
    width="430px"
    :title="title"
    class="addBrand"
    @close="onClose"
  >
    <div style="padding: 0 25px;">
      <el-form
        :model="queryParams"
        ref="queryParamsRefs"
        :rules="queryParamsRules"
        label-width="60px"
        class="demo-ruleForm"
      >
        <el-form-item label="税种：" prop="accountName">
          <el-input v-model.trim="queryParams.accountName"></el-input>
        </el-form-item>
        <el-form-item label="税率：" prop="bankName">
          <div style="display: flex">
            <el-input-number :controls="false" v-model.trim="queryParams.bankName"></el-input-number>
            <span style="margin-left: 10px;">%</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit('queryParams')">保存</el-button>
      <el-button @click="onClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addTaxRate, UpdatetaxRate } from '@/api/system/rightsManagement'
import { isSuccess } from '@/util/tool'
import NP from 'number-precision'

var _this = this
export default {
  data () {
    const accountName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入税种'))
      } else {
        callback()
      }
    }
    const balackName = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error('请输入税率'))
      } else {
        if (value / 100 <= 0) {
          return callback(new Error('税率不可小于0%'))
        } else {
          if (value / 100 >= 1) {
            return callback(new Error('税率需小于100%'))
          } else {
            callback()
          }
        }
      }
    }
    return {
      fromtype: 1,
      hasAccName: [],
      addTaxRatex: false,
      // 添加税率信息
      queryParams: {
        accountName: '', // 税种
        bankName: '' // 税率
      },
      type: 1,
      title: '',
      queryParamsRules: {
        bankName: [{ required: true, validator: balackName, trigger: 'blur' }],
        accountName: [
          { required: true, validator: accountName, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    _this = this
  },
  methods: {
    // 新增税率信息
    onInitialize (type, row) {
      _this.fromtype = type
      if (type === 1) {
        this.queryParams = {
          accountName: '', // 税种
          bankName: '' // 税率
        }
      } else {
        const { taxCount, taxName, id } = row
        _this.queryParams = {
          accountName: taxName,
          bankName: NP.strip(taxCount * 100),
          id
        }
      }

      this.title = '税率信息'
      this.addTaxRatex = true
    },
    // 确定
    onSubmit () {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          const { accountName, bankName } = this.queryParams
          const parmems = {
            createDate: '',
            createIp: 0,
            createUser: '',
            id: 0,
            state: 0,
            taxCount: NP.strip(bankName / 100),
            taxName: accountName
          }
          if (this.fromtype === 1) {
            addTaxRate(parmems).then(res => {
              if (isSuccess(res)) {
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                })
                this.addTaxRatex = false
              } else if (res.data.msg === '不可重复名字') {
                this.$message.error('保存失败，税种不可重复！')
              }
              this.$parent.getList()
            })
          } else {
            const { bankName, accountName } = this.queryParams
            const parmems = {
              createDate: '',
              createIp: 0,
              createUser: '',
              id: this.queryParams.id,
              state: 0,
              taxCount: NP.strip(bankName / 100),
              taxName: accountName
            }
            UpdatetaxRate(parmems).then(res => {
              this.$message({
                message: res.data.msg,
                type: res.data.code === 200 ? 'success' : 'error'
              })
              if (isSuccess(res)) {
                this.addTaxRatex = false
              }
              this.$parent.getList()
            })
          }
          this.$emit('load')
        } else {
          return false
        }
      })
    },
    // 取消关闭弹窗
    onClose () {
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
      this.addTaxRatex = false
    }
  }
}
</script>

<style scoped lang="less">
  /deep/.el-dialog__footer{
    padding-top: 0 !important;
  }
</style>
